var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "box" } },
    [
      _c("Header"),
      _c("Menulist"),
      _c("div", { staticClass: "box_info" }, [
        _c("div", { staticClass: "user-info-card" }, [
          _c("div", { staticClass: "user-info-left" }, [
            _vm._m(0),
            _c("div", { staticClass: "user-details" }, [
              _c("div", { staticClass: "user-company" }, [
                _vm._v(_vm._s(_vm.companyinfo.company || "未设置单位")),
              ]),
              _c("div", { staticClass: "user-meta" }, [
                _c("span", { staticClass: "meta-item meta-yscode" }, [
                  _c("i", { staticClass: "el-icon-office-building" }),
                  _c("span", { staticClass: "meta-label" }, [
                    _vm._v("信用代码"),
                  ]),
                  _c("span", { staticClass: "meta-value" }, [
                    _vm._v(_vm._s(_vm.companyinfo.yscode || "-")),
                  ]),
                ]),
                _c("span", { staticClass: "meta-item meta-phone" }, [
                  _c("i", { staticClass: "el-icon-mobile-phone" }),
                  _c("span", { staticClass: "meta-label" }, [_vm._v("手机号")]),
                  _c("span", { staticClass: "meta-value" }, [
                    _vm._v(_vm._s(_vm.companyinfo.phonenumber || "-")),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "user-actions" },
            [
              _c(
                "el-button",
                { staticClass: "btn-edit", on: { click: _vm.editinfo } },
                [_c("i", { staticClass: "el-icon-edit" }), _vm._v(" 修改信息 ")]
              ),
              _c(
                "el-button",
                { staticClass: "btn-logout", on: { click: _vm.logout } },
                [
                  _c("i", { staticClass: "el-icon-switch-button" }),
                  _vm._v(" 退出登录 "),
                ]
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "main-layout" }, [
          _c("div", { staticClass: "sidebar-menu" }, [
            _vm._m(1),
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { active: _vm.activeMenu === "order" },
                on: {
                  click: function ($event) {
                    _vm.activeMenu = "order"
                  },
                },
              },
              [_c("span", [_vm._v("订单列表")])]
            ),
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { active: _vm.activeMenu === "invoice" },
                on: {
                  click: function ($event) {
                    _vm.activeMenu = "invoice"
                  },
                },
              },
              [_c("span", [_vm._v("发票抬头")])]
            ),
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { active: _vm.activeMenu === "record" },
                on: {
                  click: function ($event) {
                    _vm.activeMenu = "record"
                  },
                },
              },
              [_c("span", [_vm._v("开票记录")])]
            ),
          ]),
          _c("div", { staticClass: "content-area" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.activeMenu === "order",
                    expression: "activeMenu === 'order'",
                  },
                ],
                staticClass: "content-section",
              },
              [
                _vm._m(2),
                _c(
                  "div",
                  { staticClass: "section-body" },
                  [
                    _c(
                      "el-table",
                      {
                        key: "tableKey",
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.getlisdatas,
                          border: "",
                          fit: "",
                          "highlight-current-row": "",
                          stripe: "",
                          "header-cell-style": {
                            background: "#ddd",
                            color: "#000000",
                          },
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { label: "单位名称", align: "center" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        content: row.company,
                                        placement: "top-start",
                                      },
                                    },
                                    [_c("span", [_vm._v(_vm._s(row.company))])]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "信用代码",
                            width: "190",
                            align: "center",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c("span", [_vm._v(_vm._s(row.yscode))]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "支付金额",
                            width: "100",
                            align: "center",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c("span", [_vm._v(_vm._s(row.totalfee))]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "年限",
                            width: "80",
                            align: "center",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c("span", [_vm._v(_vm._s(row.totalnum))]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "下单时间",
                            width: "180",
                            align: "center",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  _c("span", [_vm._v(_vm._s(row.addtime))]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "订单类型",
                            width: "90",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  row.ordertype == 5
                                    ? _c(
                                        "span",
                                        { staticStyle: { color: "#E6A23C" } },
                                        [_vm._v("网卡延期")]
                                      )
                                    : _vm._e(),
                                  row.ordertype == 6
                                    ? _c(
                                        "span",
                                        { staticStyle: { color: "#409EFF" } },
                                        [_vm._v("终端延期")]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "支付方式",
                            width: "90",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  row.paymethod == 1
                                    ? _c(
                                        "span",
                                        { staticStyle: { color: "#E6A23C" } },
                                        [_vm._v("线上办理")]
                                      )
                                    : _vm._e(),
                                  row.paymethod == 2
                                    ? _c(
                                        "span",
                                        { staticStyle: { color: "#409EFF" } },
                                        [_vm._v("线下办理")]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "订单状态",
                            width: "120",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ row }) {
                                return [
                                  row.status == 0 && row.paymethod == 1
                                    ? _c("div", { staticClass: "li" }, [
                                        _vm._v("已取消"),
                                      ])
                                    : _vm._e(),
                                  row.status == 1
                                    ? _c("div", { staticClass: "li" }, [
                                        _vm._v("支付中"),
                                      ])
                                    : _vm._e(),
                                  row.status == 2 && row.paymethod == 1
                                    ? _c("div", { staticClass: "li" }, [
                                        _vm._v("支付成功"),
                                      ])
                                    : _vm._e(),
                                  row.status == 3 && row.paymethod == 1
                                    ? _c("div", { staticClass: "li" }, [
                                        _vm._v("支付失败"),
                                      ])
                                    : _vm._e(),
                                  row.status == 4
                                    ? _c("div", { staticClass: "li" }, [
                                        _vm._v("已撤销"),
                                      ])
                                    : _vm._e(),
                                  row.status == 5
                                    ? _c("div", { staticClass: "li" }, [
                                        _vm._v("已退款"),
                                      ])
                                    : _vm._e(),
                                  row.status == 6
                                    ? _c("div", { staticClass: "li" }, [
                                        _vm._v("订单关闭"),
                                      ])
                                    : _vm._e(),
                                  row.status == 7
                                    ? _c("div", { staticClass: "li" }, [
                                        _vm._v("退款审核中"),
                                      ])
                                    : _vm._e(),
                                  row.status == 8
                                    ? _c("div", { staticClass: "li" }, [
                                        _vm._v("退款成功"),
                                      ])
                                    : _vm._e(),
                                  row.status == 9
                                    ? _c("div", { staticClass: "li" }, [
                                        _vm._v("退款失败"),
                                      ])
                                    : _vm._e(),
                                  row.status == 10
                                    ? _c("div", { staticClass: "li" }, [
                                        _vm._v("退款中"),
                                      ])
                                    : _vm._e(),
                                  row.status == 11
                                    ? _c("div", { staticClass: "li" }, [
                                        _vm._v("退款成功"),
                                      ])
                                    : _vm._e(),
                                  row.status == 12
                                    ? _c("div", { staticClass: "li" }, [
                                        _vm._v("退款失败"),
                                      ])
                                    : _vm._e(),
                                  row.status == 13
                                    ? _c("div", { staticClass: "li" }, [
                                        _vm._v("退款关闭"),
                                      ])
                                    : _vm._e(),
                                  row.status == 0 && row.paymethod == 2
                                    ? _c("div", { staticClass: "li" }, [
                                        _vm._v("待上传"),
                                      ])
                                    : _vm._e(),
                                  row.status == 14 && row.paymethod == 2
                                    ? _c("div", [_vm._v("待审核")])
                                    : _vm._e(),
                                  row.status == 2 && row.paymethod == 2
                                    ? _c("div", [_vm._v("审核成功")])
                                    : _vm._e(),
                                  row.status == 3 && row.paymethod == 2
                                    ? _c("div", [_vm._v("审核失败")])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            fixed: "right",
                            "class-name": "small-padding",
                            label: "操作",
                            width: "350",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ row, $index }) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        plain: "",
                                        size: "mini",
                                        type: "warning",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.chakanLookstatus(row)
                                        },
                                      },
                                    },
                                    [_vm._v("查看")]
                                  ),
                                  !row.sealUrl
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            plain: "",
                                            size: "mini",
                                            type: "success",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.generateAcontract(row)
                                            },
                                          },
                                        },
                                        [_vm._v("生成合同")]
                                      )
                                    : _vm._e(),
                                  row.sealUrl
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            plain: "",
                                            size: "mini",
                                            type: "success",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.previewContract(row)
                                            },
                                          },
                                        },
                                        [_vm._v("预览合同")]
                                      )
                                    : _vm._e(),
                                  row.sealUrl
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            plain: "",
                                            size: "mini",
                                            type: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.downloadContract(row)
                                            },
                                          },
                                        },
                                        [_vm._v("下载合同")]
                                      )
                                    : _vm._e(),
                                  row.originalserialno
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            plain: "",
                                            size: "mini",
                                            type: "warning",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.viewInvoicePdf(row)
                                            },
                                          },
                                        },
                                        [_vm._v("查看发票")]
                                      )
                                    : _vm._e(),
                                  _vm.canDeleteOrder(row)
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            plain: "",
                                            size: "mini",
                                            type: "danger",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.chakandetele(row)
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      )
                                    : _vm._e(),
                                  (row.status == 0 && row.paymethod == 2) ||
                                  (row.status == 3 && row.paymethod == 2)
                                    ? _c(
                                        "el-upload",
                                        {
                                          staticClass: "upload-demo",
                                          attrs: {
                                            headers: _vm.headers,
                                            action: _vm.actionurl,
                                            data: _vm.updatedata,
                                            "on-exceed": _vm.handleExceed,
                                            limit: 1,
                                            accept: ".png,.jpg",
                                            "on-success":
                                              _vm.handleuploadSuccess,
                                            "before-upload": _vm.beforeupload,
                                            "show-file-list": false,
                                            "file-list": _vm.fileList,
                                          },
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticStyle: {
                                                "margin-top": "10px",
                                              },
                                              attrs: {
                                                type: "primary",
                                                plain: "",
                                                size: "mini",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.updataphone(row.id)
                                                },
                                              },
                                            },
                                            [_vm._v("上传支付凭证")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "flex-end",
                      background: "#fff",
                      padding: "15px 20px",
                    },
                  },
                  [
                    _vm.total > 0
                      ? _c("pagination", {
                          attrs: {
                            limit: _vm.listQuery.pagesize,
                            page: _vm.listQuery.page,
                            total: _vm.total,
                          },
                          on: {
                            "update:limit": function ($event) {
                              return _vm.$set(_vm.listQuery, "pagesize", $event)
                            },
                            "update:page": function ($event) {
                              return _vm.$set(_vm.listQuery, "page", $event)
                            },
                            pagination: _vm.getlist,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
            _vm.activeMenu === "invoice"
              ? _c("div", { staticClass: "content-section" }, [
                  _c(
                    "div",
                    { staticClass: "section-header" },
                    [
                      _c("i", { staticClass: "el-icon-tickets" }),
                      _c("span", [_vm._v("发票抬头")]),
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-add-title",
                          attrs: { type: "primary" },
                          on: { click: _vm.showAddInvoiceTitle },
                        },
                        [
                          _c("i", { staticClass: "el-icon-plus" }),
                          _vm._v(" 新增抬头 "),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "invoice-body" },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.invoiceTitleLoading,
                              expression: "invoiceTitleLoading",
                            },
                          ],
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.invoiceTitleList,
                            border: "",
                            fit: "",
                            "highlight-current-row": "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "单位名称",
                              align: "center",
                              "min-width": "180",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c("span", [_vm._v(_vm._s(row.subject))]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2020147768
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "信用代码",
                              "min-width": "160",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c("span", [_vm._v(_vm._s(row.yscode))]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2650111363
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "收件邮箱",
                              "min-width": "190",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c("span", [_vm._v(_vm._s(row.email))]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1960383272
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "联系方式",
                              width: "120",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c("span", [_vm._v(_vm._s(row.phone))]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2853025080
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "开户银行",
                              "min-width": "200",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(row.bank || "-")),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1070848303
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "银行账号",
                              "min-width": "160",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(row.bankNum || "-")),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2079707897
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              width: "150",
                              align: "center",
                              fixed: "right",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.editInvoiceTitle(row)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-edit",
                                          }),
                                          _vm._v(" 编辑 "),
                                        ]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: { color: "#f56c6c" },
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteInvoiceTitle(row)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-delete",
                                          }),
                                          _vm._v(" 删除 "),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              164721401
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.activeMenu === "record"
              ? _c("div", { staticClass: "content-section" }, [
                  _c(
                    "div",
                    { staticClass: "section-header" },
                    [
                      _c("i", { staticClass: "el-icon-document-checked" }),
                      _c("span", [_vm._v("开票记录")]),
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-add-title",
                          attrs: { type: "primary" },
                          on: { click: _vm.clickshowAddInvoiceTitle },
                        },
                        [_vm._v("开票")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "invoice-body" },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.invoiceRecordLoading,
                              expression: "invoiceRecordLoading",
                            },
                          ],
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.invoiceRecordList,
                            border: "",
                            fit: "",
                            "highlight-current-row": "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "发票抬头",
                              align: "center",
                              "min-width": "180",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c("span", [_vm._v(_vm._s(row.header))]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3159789979
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "信用代码",
                              width: "180",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c("span", [_vm._v(_vm._s(row.yscode))]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2650111363
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "邮箱",
                              width: "180",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c("span", [_vm._v(_vm._s(row.email))]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1960383272
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "开户行",
                              width: "150",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(row.bank || "-")),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1070848303
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "银行账号",
                              width: "180",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(row.bankNum || "-")),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2079707897
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "状态",
                              width: "100",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      row.status === 1
                                        ? _c(
                                            "el-tag",
                                            { attrs: { type: "warning" } },
                                            [_vm._v("待开票")]
                                          )
                                        : row.status === 2
                                        ? _c(
                                            "el-tag",
                                            { attrs: { type: "success" } },
                                            [_vm._v("已开票")]
                                          )
                                        : _c(
                                            "el-tag",
                                            { attrs: { type: "danger" } },
                                            [_vm._v("未知")]
                                          ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              260491242
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "审核状态",
                              width: "100",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      row.auditstatus == 1
                                        ? _c(
                                            "el-tag",
                                            { attrs: { type: "warning" } },
                                            [_vm._v("待审核")]
                                          )
                                        : row.auditstatus == 2
                                        ? _c(
                                            "el-tag",
                                            { attrs: { type: "success" } },
                                            [_vm._v("审核通过")]
                                          )
                                        : row.auditstatus == 3
                                        ? _c(
                                            "el-tag",
                                            { attrs: { type: "danger" } },
                                            [_vm._v("审核失败")]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2771667030
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              width: "150",
                              align: "center",
                              fixed: "right",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.editInvoiceRecordlook(
                                                row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("查看")]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: { color: "#f56c6c" },
                                          attrs: {
                                            type: "text",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteInvoiceRecord(
                                                row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      ),
                                      row.auditstatus == 3
                                        ? _c(
                                            "el-button",
                                            {
                                              staticStyle: { color: "#E6A23C" },
                                              attrs: {
                                                type: "text",
                                                size: "small",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.ClickreviewdialogVisible(
                                                    row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("原因")]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2307022184
                            ),
                          }),
                        ],
                        1
                      ),
                      _vm.invoiceRecordTotal > 0
                        ? _c(
                            "div",
                            { staticClass: "pagination-wrapper" },
                            [
                              _c("el-pagination", {
                                attrs: {
                                  "current-page": _vm.invoiceRecordPage,
                                  "page-size": _vm.invoiceRecordPageSize,
                                  layout: "total, prev, pager, next",
                                  total: _vm.invoiceRecordTotal,
                                },
                                on: {
                                  "current-change":
                                    _vm.handleInvoiceRecordPageChange,
                                  "update:currentPage": function ($event) {
                                    _vm.invoiceRecordPage = $event
                                  },
                                  "update:current-page": function ($event) {
                                    _vm.invoiceRecordPage = $event
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "驳回原因",
            visible: _vm.reviewdialogVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.reviewdialogVisible = $event
            },
          },
        },
        [
          _c("p", [_vm._v(_vm._s(_vm.reviewdialogVisibletext))]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.reviewdialogVisible = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.invoiceTitleModalTitle,
            visible: _vm.invoiceTitleModalVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.invoiceTitleModalVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "invoiceTitleForm",
              staticClass: "invoice-title-form",
              attrs: {
                model: _vm.invoiceTitleForm,
                rules: _vm.invoiceTitleRules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "单位名称", prop: "subject" } },
                [
                  _c("el-autocomplete", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      "fetch-suggestions": _vm.handleCompanySearch,
                      placeholder:
                        "请输入单位名称，支持搜索选择，搜索不到可自行输入",
                      clearable: "",
                    },
                    on: {
                      select: _vm.handleCompanySelect,
                      blur: _vm.handleCompanyBlur,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ item }) {
                          return [
                            _c("div", { staticClass: "company-search-item" }, [
                              _c(
                                "div",
                                { staticClass: "company-search-name" },
                                [_vm._v(_vm._s(item.name))]
                              ),
                              _c(
                                "div",
                                { staticClass: "company-search-code" },
                                [_vm._v("信用代码: " + _vm._s(item.taxId))]
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.invoiceTitleForm.subject,
                      callback: function ($$v) {
                        _vm.$set(_vm.invoiceTitleForm, "subject", $$v)
                      },
                      expression: "invoiceTitleForm.subject",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "信用代码", prop: "yscode" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入统一社会信用代码" },
                    model: {
                      value: _vm.invoiceTitleForm.yscode,
                      callback: function ($$v) {
                        _vm.$set(_vm.invoiceTitleForm, "yscode", $$v)
                      },
                      expression: "invoiceTitleForm.yscode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "收件邮箱", prop: "email" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入收件邮箱" },
                    model: {
                      value: _vm.invoiceTitleForm.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.invoiceTitleForm, "email", $$v)
                      },
                      expression: "invoiceTitleForm.email",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "联系方式", prop: "phone" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入联系方式" },
                    model: {
                      value: _vm.invoiceTitleForm.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.invoiceTitleForm, "phone", $$v)
                      },
                      expression: "invoiceTitleForm.phone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "单位地址" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入单位地址" },
                    model: {
                      value: _vm.invoiceTitleForm.address,
                      callback: function ($$v) {
                        _vm.$set(_vm.invoiceTitleForm, "address", $$v)
                      },
                      expression: "invoiceTitleForm.address",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "开户银行" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入开户银行" },
                    model: {
                      value: _vm.invoiceTitleForm.bank,
                      callback: function ($$v) {
                        _vm.$set(_vm.invoiceTitleForm, "bank", $$v)
                      },
                      expression: "invoiceTitleForm.bank",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "银行账号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入银行账号" },
                    model: {
                      value: _vm.invoiceTitleForm.bankNum,
                      callback: function ($$v) {
                        _vm.$set(_vm.invoiceTitleForm, "bankNum", $$v)
                      },
                      expression: "invoiceTitleForm.bankNum",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.invoiceTitleModalVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.invoiceTitleSubmitting,
                  },
                  on: { click: _vm.submitInvoiceTitle },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "详情",
            visible: _vm.dialogVisibleDetails,
            width: "90%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleDetails = $event
            },
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                {
                  attrs: {
                    span:
                      _vm.invoicelist.length == 0 && _vm.dakuanimgurl == ""
                        ? 24
                        : 16,
                  },
                },
                [
                  _c(
                    "el-divider",
                    { attrs: { "content-position": "center" } },
                    [_vm._v("使用单位信息")]
                  ),
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("div", { staticClass: "box_list" }, [
                              _c("div", { staticClass: "box_list_title" }, [
                                _vm._v("单位名称："),
                              ]),
                              _c("div", { staticClass: "box_list_content" }, [
                                _vm._v(_vm._s(_vm.orderinfo.company)),
                              ]),
                            ]),
                          ]),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("div", { staticClass: "box_list" }, [
                              _c("div", { staticClass: "box_list_title" }, [
                                _vm._v("信用代码："),
                              ]),
                              _c("div", { staticClass: "box_list_content" }, [
                                _vm._v(_vm._s(_vm.orderinfo.yscode)),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("div", { staticClass: "box_list" }, [
                              _c("div", { staticClass: "box_list_title" }, [
                                _vm._v("联系人："),
                              ]),
                              _c("div", { staticClass: "box_list_content" }, [
                                _vm._v(_vm._s(_vm.orderinfo.name)),
                              ]),
                            ]),
                          ]),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("div", { staticClass: "box_list" }, [
                              _c("div", { staticClass: "box_list_title" }, [
                                _vm._v("联系方式："),
                              ]),
                              _c("div", { staticClass: "box_list_content" }, [
                                _vm._v(_vm._s(_vm.orderinfo.phone)),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-divider",
                    { attrs: { "content-position": "center" } },
                    [_vm._v("订单信息")]
                  ),
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("div", { staticClass: "box_list" }, [
                              _c("div", { staticClass: "box_list_title" }, [
                                _vm._v("订单号："),
                              ]),
                              _c("div", { staticClass: "box_list_content" }, [
                                _vm._v(_vm._s(_vm.orderinfo.id)),
                              ]),
                            ]),
                          ]),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("div", { staticClass: "box_list" }, [
                              _c("div", { staticClass: "box_list_title" }, [
                                _vm._v("购买时间："),
                              ]),
                              _c("div", { staticClass: "box_list_content" }, [
                                _vm._v(_vm._s(_vm.orderinfo.addtime)),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("div", { staticClass: "box_list" }, [
                              _c("div", { staticClass: "box_list_title" }, [
                                _vm._v("订单状态："),
                              ]),
                              _c("div", { staticClass: "box_list_content" }, [
                                _vm.orderinfo.status == 0
                                  ? _c("div", [_vm._v("订单生成")])
                                  : _vm._e(),
                                _vm.orderinfo.status == 1
                                  ? _c("div", [_vm._v("支付中")])
                                  : _vm._e(),
                                _vm.orderinfo.status == 2 &&
                                _vm.orderinfo.paymethod == 1
                                  ? _c("div", [_vm._v("支付成功")])
                                  : _vm._e(),
                                _vm.orderinfo.status == 3 &&
                                _vm.orderinfo.paymethod == 1
                                  ? _c("div", [_vm._v("支付失败")])
                                  : _vm._e(),
                                _vm.orderinfo.status == 4
                                  ? _c("div", [_vm._v("已撤销")])
                                  : _vm._e(),
                                _vm.orderinfo.status == 5
                                  ? _c("div", [_vm._v("已退款")])
                                  : _vm._e(),
                                _vm.orderinfo.status == 6
                                  ? _c("div", [_vm._v("订单关闭")])
                                  : _vm._e(),
                                _vm.orderinfo.status == 7
                                  ? _c("div", [_vm._v("退款审核中")])
                                  : _vm._e(),
                                _vm.orderinfo.status == 8
                                  ? _c("div", [_vm._v("退款成功")])
                                  : _vm._e(),
                                _vm.orderinfo.status == 9
                                  ? _c("div", [_vm._v("退款失败")])
                                  : _vm._e(),
                                _vm.orderinfo.status == 10
                                  ? _c("div", [_vm._v("退款中")])
                                  : _vm._e(),
                                _vm.orderinfo.status == 11
                                  ? _c("div", [_vm._v("退款成功")])
                                  : _vm._e(),
                                _vm.orderinfo.status == 12
                                  ? _c("div", [_vm._v("退款失败")])
                                  : _vm._e(),
                                _vm.orderinfo.status == 13
                                  ? _c("div", [_vm._v("退款关闭")])
                                  : _vm._e(),
                                _vm.orderinfo.status == 14 &&
                                _vm.orderinfo.paymethod == 2
                                  ? _c("div", [_vm._v("待审核")])
                                  : _vm._e(),
                                _vm.orderinfo.status == 2 &&
                                _vm.orderinfo.paymethod == 2
                                  ? _c("div", [_vm._v("审核成功")])
                                  : _vm._e(),
                                _vm.orderinfo.status == 3 &&
                                _vm.orderinfo.paymethod == 2
                                  ? _c("div", [_vm._v("审核失败")])
                                  : _vm._e(),
                              ]),
                            ]),
                          ]),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("div", { staticClass: "box_list" }, [
                              _c("div", { staticClass: "box_list_title" }, [
                                _vm._v("购买年限："),
                              ]),
                              _c("div", { staticClass: "box_list_content" }, [
                                _vm._v(_vm._s(_vm.orderinfo.totalnum)),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("div", { staticClass: "box_list" }, [
                              _c("div", { staticClass: "box_list_title" }, [
                                _vm._v("购买单价："),
                              ]),
                              _c("div", { staticClass: "box_list_content" }, [
                                _vm._v(" " + _vm._s(_vm.orderinfo.price)),
                              ]),
                            ]),
                          ]),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("div", { staticClass: "box_list" }, [
                              _c("div", { staticClass: "box_list_title" }, [
                                _vm._v("消费金额："),
                              ]),
                              _c("div", { staticClass: "box_list_content" }, [
                                _vm._v(" " + _vm._s(_vm.orderinfo.totalfee)),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-divider",
                    { attrs: { "content-position": "center" } },
                    [_vm._v("列表信息")]
                  ),
                  _vm.orderinfo.ordertype == 5
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-table",
                            {
                              key: "tableKey",
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.datas,
                                border: "",
                                fit: "",
                                "highlight-current-row": "",
                                stripe: "",
                                "header-cell-style": {
                                  background: "#ddd",
                                  color: "#000000",
                                },
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { label: "单位名称", align: "center" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _c("span", [
                                            _vm._v(_vm._s(row.ybdept)),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2254250426
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "信用代码",
                                  width: "190",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _c("span", [
                                            _vm._v(_vm._s(row.yscode)),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2650111363
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "ICCID(卡号)",
                                  width: "200",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _c("span", [
                                            _vm._v(_vm._s(row.iccid)),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3349639904
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "终端医保SN",
                                  width: "200",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _c("span", [
                                            _vm._v(_vm._s(row.ybsn)),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  4173626242
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "终端设备SN",
                                  width: "200",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _c("span", [_vm._v(_vm._s(row.sn))]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2868682873
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.orderinfo.ordertype == 6
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-table",
                            {
                              key: "tableKey",
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.datas,
                                border: "",
                                fit: "",
                                "highlight-current-row": "",
                                stripe: "",
                                "header-cell-style": {
                                  background: "#ddd",
                                  color: "#000000",
                                },
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { label: "终端名称", align: "center" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _c("span", [
                                            _vm._v(_vm._s(row.title)),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1914559620
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "型号",
                                  width: "190",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _c("span", [
                                            _vm._v(_vm._s(row.model)),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2085099979
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: { label: "终端医保SN", align: "center" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _c("span", [
                                            _vm._v(_vm._s(row.ybsn)),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  4173626242
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: { label: "终端设备SN", align: "center" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _c("span", [_vm._v(_vm._s(row.sn))]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2868682873
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-col",
                {
                  attrs: {
                    span:
                      _vm.invoicelist.length != 0 || _vm.dakuanimgurl != ""
                        ? 8
                        : 0,
                  },
                },
                [
                  _vm.orderinfo.paymethod == 2 &&
                  _vm.orderinfo.paymentvoucher != ""
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "center" } },
                            [_vm._v("付款凭证")]
                          ),
                          _c(
                            "el-timeline",
                            { attrs: { reverse: _vm.reverses } },
                            _vm._l(_vm.srcList, function (activity, index) {
                              return _c(
                                "el-card",
                                { staticStyle: { "border-radius": "5rpx" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "clearfix",
                                      attrs: { slot: "header" },
                                      slot: "header",
                                    },
                                    [_c("b", [_vm._v("线下付款凭证")])]
                                  ),
                                  _c("el-image", {
                                    staticStyle: {
                                      width: "200px",
                                      "max-height": "200px",
                                      margin: "0 auto",
                                    },
                                    attrs: {
                                      src: _vm.dakuanimgurl,
                                      "preview-src-list": _vm.srcList,
                                      fit: _vm.contain,
                                    },
                                  }),
                                  _vm.dakuanimgurl != "" &&
                                  ((_vm.orderinfo.status != 2 &&
                                    _vm.orderinfo.paymethod != 1) ||
                                    (_vm.orderinfo.status != 2 &&
                                      _vm.orderinfo.paymethod != 2))
                                    ? _c(
                                        "el-upload",
                                        {
                                          staticClass: "upload-demo",
                                          attrs: {
                                            headers: _vm.headers,
                                            action: _vm.actionurl,
                                            data: _vm.updatedata,
                                            "on-exceed": _vm.handleExceed,
                                            limit: 1,
                                            accept: ".png,.jpg",
                                            "on-success":
                                              _vm.handleuploadSuccess,
                                            "before-upload": _vm.beforeupload,
                                            "show-file-list": false,
                                            "file-list": _vm.fileList,
                                          },
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticStyle: {
                                                "margin-top": "10px",
                                              },
                                              attrs: {
                                                type: "text",
                                                plain: "",
                                                size: "mini",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.updataphone(
                                                    _vm.orderinfo.id
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("传错了？重新上传")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.invoicelist.length != 0
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "center" } },
                            [_vm._v("发票信息")]
                          ),
                          _c(
                            "el-timeline",
                            { attrs: { reverse: _vm.reverse } },
                            _vm._l(_vm.invoicelist, function (activity, index) {
                              return _c(
                                "el-card",
                                { staticClass: "box-card" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "clearfix",
                                      attrs: { slot: "header" },
                                      slot: "header",
                                    },
                                    [
                                      _c("b", [_vm._v("发票信息")]),
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            float: "right",
                                            padding: "3px 0",
                                          },
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.Downloadinvoicexiazai(
                                                activity,
                                                index
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("下载发票")]
                                      ),
                                    ],
                                    1
                                  ),
                                  activity.img != ""
                                    ? _c("el-image", {
                                        staticStyle: {
                                          width: "200px",
                                          "max-height": "200px",
                                          margin: "0 auto",
                                        },
                                        attrs: {
                                          src: activity.img,
                                          "preview-src-list": activity.imglist,
                                          fit: _vm.contain,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisibleDetails = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisibleDetails = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "申请开票",
            visible: _vm.Invoicerequeststatus,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.Invoicerequeststatus = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "单位名称", prop: "subject" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.ruleForm.subject,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "subject", $$v)
                              },
                              expression: "ruleForm.subject",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "信用代码", prop: "yscode" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.ruleForm.yscode,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "yscode", $$v)
                              },
                              expression: "ruleForm.yscode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "电子邮箱", prop: "email" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.ruleForm.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "email", $$v)
                              },
                              expression: "ruleForm.email",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "注意事项", prop: "name" } },
                        [_c("span", [_vm._v("注：请不要填写企业内部邮箱！")])]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "联系人", prop: "name" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.ruleForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "name", $$v)
                              },
                              expression: "ruleForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "联系电话", prop: "phone" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.ruleForm.phone,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "phone", $$v)
                              },
                              expression: "ruleForm.phone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.resetForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v("立即申请")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "申请开票",
            visible: _vm.invoiceModalVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.invoiceModalVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.invoiceModalLoading,
                  expression: "invoiceModalLoading",
                },
              ],
            },
            [
              _c("div", { staticClass: "invoice-section" }, [
                _c("h4", { staticClass: "section-subtitle" }, [
                  _c("i", { staticClass: "el-icon-document-checked" }),
                  _vm._v(
                    " 已选订单 (" + _vm._s(_vm.selectedOrderIds.length) + "个) "
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "selected-orders" },
                  _vm._l(_vm.selectedOrderIds, function (orderId) {
                    return _c(
                      "div",
                      { key: orderId, staticClass: "order-tag" },
                      [
                        _c(
                          "el-tag",
                          { attrs: { size: "small", type: "info" } },
                          [_vm._v("订单号: " + _vm._s(orderId))]
                        ),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
              _c(
                "div",
                { staticClass: "invoice-section" },
                [
                  _c("h4", { staticClass: "section-subtitle" }, [
                    _c("i", { staticClass: "el-icon-office-building" }),
                    _vm._v(" 选择发票抬头 "),
                  ]),
                  _c(
                    "el-radio-group",
                    {
                      staticStyle: { width: "100%" },
                      model: {
                        value: _vm.selectedInvoiceTitleId,
                        callback: function ($$v) {
                          _vm.selectedInvoiceTitleId = $$v
                        },
                        expression: "selectedInvoiceTitleId",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "invoice-title-list" },
                        [
                          _vm._l(_vm.invoiceTitleList, function (item) {
                            return _c(
                              "el-radio",
                              {
                                key: item.id,
                                staticClass: "invoice-title-item",
                                attrs: { label: item.id },
                              },
                              [
                                _c("div", { staticClass: "title-info" }, [
                                  _c("span", { staticClass: "title-name" }, [
                                    _vm._v(_vm._s(item.subject)),
                                  ]),
                                  _c("span", { staticClass: "title-code" }, [
                                    _vm._v(_vm._s(item.yscode)),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          _vm.invoiceTitleList.length === 0
                            ? _c("div", { staticClass: "empty-tips" }, [
                                _c("i", { staticClass: "el-icon-info" }),
                                _vm._v(" 暂无发票抬头，请先添加 "),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "invoice-section" },
                [
                  _c("h4", { staticClass: "section-subtitle" }, [
                    _c("i", { staticClass: "el-icon-document" }),
                    _vm._v(" 选择发票类型 "),
                  ]),
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.invoiceType,
                        callback: function ($$v) {
                          _vm.invoiceType = $$v
                        },
                        expression: "invoiceType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("增值税普通发票"),
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("增值税专用发票"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.invoiceModalVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.invoiceModalLoading },
                  on: { click: _vm.submitInvoice },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择开票",
            visible: _vm.invoicestatus,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.invoicestatus = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "section-header" },
            [
              _c("i", { staticClass: "el-icon-tickets" }),
              _c("span", [_vm._v("开票")]),
              _vm.selectedOrderKeys.length != 0
                ? _c(
                    "a-button",
                    {
                      staticClass: "btn-add-title",
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.invoice(1, 1)
                        },
                      },
                    },
                    [_vm._v("开票")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("a-table", {
            attrs: {
              columns: _vm.scolumns,
              "row-key": (record) => record.id,
              "data-source": _vm.sdatas,
              pagination: _vm.pagination,
              loading: _vm.loading,
              bordered: true,
              "row-selection": {
                selectedRowKeys: _vm.selectedOrderKeys,
                onChange: _vm.onSelectOrderChange,
              },
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "company",
                fn: function (datas, record) {
                  return [
                    _c(
                      "a-tooltip",
                      {
                        staticStyle: { width: "180" },
                        attrs: { placement: "top" },
                      },
                      [
                        _c("template", { slot: "title" }, [
                          _c("span", [_vm._v(_vm._s(record.company))]),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "block",
                              width: "100px",
                              overflow: "hidden",
                              "text-overflow": "ellipsis",
                              "white-space": "nowrap",
                              cursor: "pointer",
                            },
                          },
                          [_vm._v(_vm._s(record.company))]
                        ),
                      ],
                      2
                    ),
                  ]
                },
              },
              {
                key: "yscode",
                fn: function (datas, record) {
                  return [
                    _c(
                      "a-tooltip",
                      {
                        staticStyle: { width: "180" },
                        attrs: { placement: "top" },
                      },
                      [
                        _c("template", { slot: "title" }, [
                          _c("span", [_vm._v(_vm._s(record.yscode))]),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "block",
                              width: "100px",
                              overflow: "hidden",
                              "text-overflow": "ellipsis",
                              "white-space": "nowrap",
                              cursor: "pointer",
                            },
                          },
                          [_vm._v(_vm._s(record.yscode))]
                        ),
                      ],
                      2
                    ),
                  ]
                },
              },
              {
                key: "totalfee",
                fn: function (datas, record) {
                  return [
                    _c(
                      "a-tooltip",
                      { attrs: { placement: "top" } },
                      [
                        _c("template", { slot: "title" }, [
                          _c("span", [_vm._v(_vm._s(record.totalfee))]),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "block",
                              overflow: "hidden",
                              "text-overflow": "ellipsis",
                              "white-space": "nowrap",
                              cursor: "pointer",
                            },
                          },
                          [_vm._v(_vm._s(record.totalfee))]
                        ),
                      ],
                      2
                    ),
                  ]
                },
              },
              {
                key: "addtime",
                fn: function (datas, record) {
                  return [
                    _c(
                      "a-tooltip",
                      {
                        staticStyle: { width: "100" },
                        attrs: { placement: "top" },
                      },
                      [
                        _c("template", { slot: "title" }, [
                          _c("span", [_vm._v(_vm._s(record.addtime))]),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "block",
                              width: "100px",
                              overflow: "hidden",
                              "text-overflow": "ellipsis",
                              "white-space": "nowrap",
                              cursor: "pointer",
                            },
                          },
                          [_vm._v(_vm._s(record.addtime))]
                        ),
                      ],
                      2
                    ),
                  ]
                },
              },
              {
                key: "ordertype",
                fn: function (datas, record) {
                  return [
                    record.ordertype == 5
                      ? _c("span", { staticStyle: { color: "#E6A23C" } }, [
                          _vm._v("网卡延期"),
                        ])
                      : _vm._e(),
                    record.ordertype == 6
                      ? _c("span", { staticStyle: { color: "#409EFF" } }, [
                          _vm._v("终端延期"),
                        ])
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "actions",
                fn: function (datas, record) {
                  return [
                    record.status == 0
                      ? _c("div", { staticClass: "li" }, [_vm._v("待支付")])
                      : _vm._e(),
                    record.status == 1
                      ? _c("div", { staticClass: "li" }, [_vm._v("支付中")])
                      : _vm._e(),
                    record.status == 2
                      ? _c("div", { staticClass: "li" }, [_vm._v("支付成功")])
                      : _vm._e(),
                    record.status == 3
                      ? _c("div", { staticClass: "li" }, [_vm._v("支付失败")])
                      : _vm._e(),
                    record.status == 4
                      ? _c("div", { staticClass: "li" }, [_vm._v("已撤销")])
                      : _vm._e(),
                    record.status == 5
                      ? _c("div", { staticClass: "li" }, [_vm._v("已退款")])
                      : _vm._e(),
                    record.status == 6
                      ? _c("div", { staticClass: "li" }, [_vm._v("订单关闭")])
                      : _vm._e(),
                    record.status == 7
                      ? _c("div", { staticClass: "li" }, [_vm._v("退款审核中")])
                      : _vm._e(),
                    record.status == 8
                      ? _c("div", { staticClass: "li" }, [_vm._v("退款成功")])
                      : _vm._e(),
                    record.status == 9
                      ? _c("div", { staticClass: "li" }, [_vm._v("退款失败")])
                      : _vm._e(),
                    record.status == 10
                      ? _c("div", { staticClass: "li" }, [_vm._v("退款中")])
                      : _vm._e(),
                    record.status == 11
                      ? _c("div", { staticClass: "li" }, [_vm._v("退款成功")])
                      : _vm._e(),
                    record.status == 12
                      ? _c("div", { staticClass: "li" }, [_vm._v("退款失败")])
                      : _vm._e(),
                    record.status == 13
                      ? _c("div", { staticClass: "li" }, [_vm._v("退款关闭")])
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "action",
                fn: function (datas, record) {
                  return [
                    record.status == 2
                      ? _c(
                          "a",
                          {
                            attrs: { href: "javascript:;" },
                            on: {
                              click: function ($event) {
                                return _vm.invoice(record, 0)
                              },
                            },
                          },
                          [_vm._v("开票")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "invoice-detail-dialog",
          attrs: {
            title: "记录详情",
            visible: _vm.invoiceRecordDetailVisible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.invoiceRecordDetailVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "detail-section" }, [
            _c("div", { staticClass: "detail-section-title" }, [
              _c("span", { staticClass: "section-line" }),
              _c("span", [_vm._v("开票信息")]),
            ]),
            _c(
              "div",
              { staticClass: "detail-info-content" },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 40 } },
                  [
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("发票抬头："),
                        ]),
                        _c("span", { staticClass: "info-value" }, [
                          _vm._v(_vm._s(_vm.invoiceRecordDetail.header)),
                        ]),
                      ]),
                    ]),
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("信用代码："),
                        ]),
                        _c("span", { staticClass: "info-value" }, [
                          _vm._v(_vm._s(_vm.invoiceRecordDetail.yscode)),
                        ]),
                      ]),
                    ]),
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c(
                        "div",
                        { staticClass: "info-row" },
                        [
                          _c("span", { staticClass: "info-label" }, [
                            _vm._v("发票类型："),
                          ]),
                          _vm.invoiceRecordDetail.invoiceType == 2
                            ? _c(
                                "el-tag",
                                { attrs: { size: "small", type: "warning" } },
                                [_vm._v("专票")]
                              )
                            : _c(
                                "el-tag",
                                { attrs: { size: "small", type: "success" } },
                                [_vm._v("普票")]
                              ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 40 } },
                  [
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("邮箱："),
                        ]),
                        _c("span", { staticClass: "info-value" }, [
                          _vm._v(_vm._s(_vm.invoiceRecordDetail.email)),
                        ]),
                      ]),
                    ]),
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("开户行："),
                        ]),
                        _c("span", { staticClass: "info-value" }, [
                          _vm._v(_vm._s(_vm.invoiceRecordDetail.bank || "-")),
                        ]),
                      ]),
                    ]),
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("银行账号："),
                        ]),
                        _c("span", { staticClass: "info-value" }, [
                          _vm._v(
                            _vm._s(_vm.invoiceRecordDetail.bankNum || "-")
                          ),
                        ]),
                      ]),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 40 } },
                  [
                    _c("el-col", { attrs: { span: 16 } }, [
                      _c("div", { staticClass: "info-row" }, [
                        _c("span", { staticClass: "info-label" }, [
                          _vm._v("地址："),
                        ]),
                        _c("span", { staticClass: "info-value" }, [
                          _vm._v(
                            _vm._s(_vm.invoiceRecordDetail.address || "-")
                          ),
                        ]),
                      ]),
                    ]),
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c(
                        "div",
                        { staticClass: "info-row" },
                        [
                          _c("span", { staticClass: "info-label" }, [
                            _vm._v("状态："),
                          ]),
                          _vm.invoiceRecordDetail.status === 1
                            ? _c(
                                "el-tag",
                                { attrs: { size: "small", type: "warning" } },
                                [_vm._v("待开票")]
                              )
                            : _vm.invoiceRecordDetail.status === 2
                            ? _c(
                                "el-tag",
                                { attrs: { size: "small", type: "success" } },
                                [_vm._v("已开票")]
                              )
                            : _c(
                                "el-tag",
                                { attrs: { size: "small", type: "info" } },
                                [_vm._v("未知")]
                              ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "detail-section" }, [
            _c("div", { staticClass: "detail-section-title" }, [
              _c("span", { staticClass: "section-line" }),
              _c("span", [_vm._v("关联订单")]),
            ]),
            _c(
              "div",
              { staticClass: "detail-table-content" },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.invoiceRecordDetailOrders,
                      border: "",
                      fit: "",
                      "highlight-current-row": "",
                      "max-height": "400",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "单位名称",
                        align: "center",
                        "min-width": "150",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [_c("span", [_vm._v(_vm._s(row.company))])]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "信用代码",
                        align: "center",
                        width: "180",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [_c("span", [_vm._v(_vm._s(row.yscode))])]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "年限", align: "center", width: "100" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c("span", [_vm._v(_vm._s(row.totalnum || "-"))]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "消费金额",
                        align: "center",
                        width: "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [_c("span", [_vm._v(_vm._s(row.totalfee))])]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "联系人", align: "center", width: "100" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [_c("span", [_vm._v(_vm._s(row.name))])]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "联系电话",
                        align: "center",
                        width: "130",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [_c("span", [_vm._v(_vm._s(row.phone))])]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "订单类型",
                        align: "center",
                        width: "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              row.ordertype == 5
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "#E6A23C" } },
                                    [_vm._v("网卡延期")]
                                  )
                                : row.ordertype == 6
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "#409EFF" } },
                                    [_vm._v("终端延期")]
                                  )
                                : row.ordertype == 1
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "#409EFF" } },
                                    [_vm._v("KEY订单")]
                                  )
                                : row.ordertype == 2
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "#67C23A" } },
                                    [_vm._v("制图服务")]
                                  )
                                : row.ordertype == 3
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "#E6A23C" } },
                                    [_vm._v("服务续费")]
                                  )
                                : row.ordertype == 4
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "#E6A23C" } },
                                    [_vm._v("人工制图")]
                                  )
                                : _c("span", [_vm._v("-")]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "购买时间",
                        align: "center",
                        width: "160",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [_c("span", [_vm._v(_vm._s(row.addtime))])]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作", align: "center", width: "120" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.viewInvoicePdfByOrder(row)
                                    },
                                  },
                                },
                                [_vm._v("查看发票")]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.invoiceRecordDetailVisible = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "发票查看",
            visible: _vm.invoicePdfVisible,
            width: "60%",
            "before-close": _vm.closeInvoicePdf,
          },
          on: {
            "update:visible": function ($event) {
              _vm.invoicePdfVisible = $event
            },
          },
        },
        [
          _vm.invoicePdfUrl
            ? _c("div", { staticClass: "invoice-pdf-container" }, [
                _c("iframe", {
                  attrs: {
                    src: _vm.invoicePdfUrl,
                    width: "100%",
                    height: "600px",
                    frameborder: "0",
                  },
                }),
              ])
            : _c("div", { staticClass: "invoice-empty" }, [
                _c("i", { staticClass: "el-icon-document-delete" }),
                _c("p", [_vm._v("暂无发票文件")]),
              ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.closeInvoicePdf },
                },
                [_vm._v("关 闭")]
              ),
              _vm.invoicePdfUrl
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "success" },
                      on: { click: _vm.downloadInvoicePdf },
                    },
                    [_vm._v("下 载")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.contractPreviewLoading,
              expression: "contractPreviewLoading",
            },
          ],
          attrs: {
            title: "合同预览",
            visible: _vm.contractPreviewVisible,
            width: "70%",
            "before-close": _vm.closeContractPreview,
            "element-loading-text": "合同加载中...",
          },
          on: {
            "update:visible": function ($event) {
              _vm.contractPreviewVisible = $event
            },
          },
        },
        [
          _vm.contractPreviewUrl
            ? _c("div", { staticClass: "invoice-pdf-container" }, [
                _c("iframe", {
                  attrs: {
                    src: _vm.contractPreviewUrl,
                    width: "100%",
                    height: "600px",
                    frameborder: "0",
                  },
                }),
              ])
            : !_vm.contractPreviewLoading
            ? _c("div", { staticClass: "invoice-empty" }, [
                _c("i", { staticClass: "el-icon-document-delete" }),
                _c("p", [_vm._v("暂无合同文件")]),
              ])
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.closeContractPreview },
                },
                [_vm._v("关 闭")]
              ),
              _vm.contractPreviewUrl
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "success" },
                      on: { click: _vm.downloadContractByUrl },
                    },
                    [_vm._v("下 载")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c("Footer"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "user-avatar" }, [
      _c("i", { staticClass: "el-icon-s-custom" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "menu-header" }, [
      _c("i", { staticClass: "el-icon-menu" }),
      _c("span", [_vm._v("用户中心")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section-header" }, [
      _c("i", { staticClass: "el-icon-document" }),
      _c("span", [_vm._v("订单列表")]),
      _c(
        "span",
        { staticStyle: { "font-weight": "normal", "font-size": "12px" } },
        [
          _vm._v(
            "(支付完成订单请在3-5天点击开票记录，开票按钮。进行选择订单开票)"
          ),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }